var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 128,
    viewBox: "0 0 161 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_317_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.87109 5.30446C3.87109 2.37489 6.24598 0 9.17555 0H151.752C154.682 0 157.057 2.37489 157.057 5.30446V21.0878H3.87109V5.30446Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.87109,
    y: 16.5691,
    width: 153.186,
    height: 103.431,
    rx: 3.53631,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87109 16.5691H7.3926L3.87109 21.0879V16.5691Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.057 16.5691L157.057 20.5858L152.655 16.5691L157.057 16.5691Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 9,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.0098,
    y: 75.5769,
    width: 12.6428,
    height: 21.6311,
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.832,
    y: 68.3663,
    width: 12.6428,
    height: 28.8415,
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.742,
    y: 55.1475,
    width: 12.6428,
    height: 42.0605,
    fill: "#55C58B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9199,
    y: 61.1562,
    width: 12.6428,
    height: 36.0519,
    fill: "#55C58B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5898 62.3577L70.188 46.1926L87.0451 56.95L107.315 39.6654",
    stroke: "#FFE607",
    strokeWidth: 2.65223,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_317_734",
    x: 0.334788,
    y: 0,
    width: 160.258,
    height: 127.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.53631
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_317_734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_317_734",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e46873e055a15f61d72f8b1a6ddbf982.svg";
export { ForwardRef as ReactComponent };